import React from 'react';

const Norway = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#BA0C2F" /><rect x="6" width="4" height="16" fill="#fff" /><rect y="6" width="22" height="4" fill="#fff" /><rect x="7" width="2" height="16" fill="#00205B" /><rect y="7" width="22" height="2" fill="#00205B" /></svg>
);

const UK = (props) => (
  <svg viewBox="0 0 60 30" {...props} aria-hidden="true">
    <clipPath id="ukc"><path d="M0 0v30h60V0z" /></clipPath>
    <path d="M0 0v30h60V0z" fill="#012169" />
    <path d="M0 0l60 30m0-30L0 30" stroke="#fff" strokeWidth="6" />
    <path d="M0 0l60 30m0-30L0 30" clipPath="url(#ukc)" stroke="#C8102E" strokeWidth="4" />
    <path d="M30 0v30M0 15h60" stroke="#fff" strokeWidth="10" />
    <path d="M30 0v30M0 15h60" stroke="#C8102E" strokeWidth="6" />
  </svg>
);

const Poland = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="8" fill="#fff" /><rect y="8" width="22" height="8" fill="#dc143c" /></svg>
);

const Germany = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="5.34" fill="#000" /><rect y="5.33" width="22" height="5.34" fill="#dd0000" /><rect y="10.66" width="22" height="5.34" fill="#ffce00" /></svg>
);

const Spain = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="4" fill="#aa151b" /><rect y="4" width="22" height="8" fill="#f1bf00" /><rect y="12" width="22" height="4" fill="#aa151b" /></svg>
);

const France = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="7.34" height="16" fill="#002395" /><rect x="7.33" width="7.34" height="16" fill="#fff" /><rect x="14.66" width="7.34" height="16" fill="#ed2939" /></svg>
);

const Ukraine = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="8" fill="#0057b7" /><rect y="8" width="22" height="8" fill="#ffd700" /></svg>
);

const SaudiArabia = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#006c35" /><path d="M4 10h14M6 12h10" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" /></svg>
);

const Sweden = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#006aa7" /><rect x="6" width="2" height="16" fill="#fecc00" /><rect y="7" width="22" height="2" fill="#fecc00" /></svg>
);

const Denmark = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#c8102e" /><rect x="6" width="3" height="16" fill="#fff" /><rect y="6.5" width="22" height="3" fill="#fff" /></svg>
);

const Netherlands = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="5.34" fill="#ae1c28" /><rect y="5.33" width="22" height="5.34" fill="#fff" /><rect y="10.66" width="22" height="5.34" fill="#21468b" /></svg>
);

const Finland = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#fff" /><rect x="6" width="3" height="16" fill="#003580" /><rect y="6.5" width="22" height="3" fill="#003580" /></svg>
);

const Iceland = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#02529c" /><rect x="6" width="4" height="16" fill="#fff" /><rect y="6" width="22" height="4" fill="#fff" /><rect x="7" width="2" height="16" fill="#dc1e35" /><rect y="7" width="22" height="2" fill="#dc1e35" /></svg>
);

const Portugal = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="9" height="16" fill="#046a38" /><rect x="9" width="13" height="16" fill="#da291c" /></svg>
);

const Italy = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="7.34" height="16" fill="#009246" /><rect x="7.33" width="7.34" height="16" fill="#fff" /><rect x="14.66" width="7.34" height="16" fill="#ce2b37" /></svg>
);

const Russia = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="5.34" fill="#fff" /><rect y="5.33" width="22" height="5.34" fill="#0039a6" /><rect y="10.66" width="22" height="5.34" fill="#d52b1e" /></svg>
);

const China = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#de2910" /><path d="M5 2.5l.8 2.1 2.2.1-1.7 1.3.6 2.1L5 6.9l-1.9 1.2.6-2.1L2 4.7l2.2-.1z" fill="#ffde00" /></svg>
);

const Turkey = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#e30a17" /><circle cx="9" cy="8" r="4" fill="#fff" /><circle cx="10" cy="8" r="3.2" fill="#e30a17" /><path d="M14 5.4l.7 2 2.1.1-1.6 1.2.6 2-1.8-1.2-1.8 1.2.6-2-1.6-1.2 2.1-.1z" fill="#fff" /></svg>
);

const Romania = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="7.34" height="16" fill="#002b7f" /><rect x="7.33" width="7.34" height="16" fill="#fcd116" /><rect x="14.66" width="7.34" height="16" fill="#ce1126" /></svg>
);

const Lithuania = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="5.34" fill="#fdb913" /><rect y="5.33" width="22" height="5.34" fill="#006a44" /><rect y="10.66" width="22" height="5.34" fill="#c1272d" /></svg>
);

const Estonia = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="5.34" fill="#4891d9" /><rect y="5.33" width="22" height="5.34" fill="#000" /><rect y="10.66" width="22" height="5.34" fill="#fff" /></svg>
);

const Japan = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#fff" /><circle cx="11" cy="8" r="4.2" fill="#bc002d" /></svg>
);

const India = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="5.34" fill="#ff9933" /><rect y="5.33" width="22" height="5.34" fill="#fff" /><rect y="10.66" width="22" height="5.34" fill="#138808" /><circle cx="11" cy="8" r="1.7" fill="none" stroke="#000080" strokeWidth=".5" /></svg>
);

const Somalia = (props) => (
  <svg viewBox="0 0 22 16" {...props} aria-hidden="true"><rect width="22" height="16" fill="#4189dd" /><path d="M11 4.5l.9 2.3 2.5.1-1.9 1.5.7 2.4-2.2-1.4-2.2 1.4.7-2.4-1.9-1.5 2.5-.1z" fill="#fff" /></svg>
);

export const Flag = ({ code, className = 'w-5 h-3.5 rounded-[2px]' }) => {
  const FlagComponent = { gb: UK, pl: Poland, de: Germany, es: Spain, fr: France, ua: Ukraine, sa: SaudiArabia, se: Sweden, dk: Denmark, nl: Netherlands, fi: Finland, is: Iceland, pt: Portugal, it: Italy, ru: Russia, cn: China, tr: Turkey, ro: Romania, lt: Lithuania, ee: Estonia, jp: Japan, in: India, so: Somalia }[code] || Norway;
  return <FlagComponent className={className} />;
};
